/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type AboutAccountViewQueryVariables = Types.Exact<{
  [key: string]: never
}>

export type AboutAccountViewQuery = {
  __typename?: 'Query'
  organizations: Array<{
    __typename?: 'BackofficeOrganization'
    id: string
    name: string
  }>
}

export const AboutAccountViewDocument = gql`
    query AboutAccountView {
  organizations: backofficeOrganizations {
    id
    name
  }
}
    `

/**
 * __useAboutAccountViewQuery__
 *
 * To run a query within a React component, call `useAboutAccountViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useAboutAccountViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAboutAccountViewQuery({
 *   variables: {
 *   },
 * });
 */
export function useAboutAccountViewQuery(
  baseOptions?: Apollo.QueryHookOptions<
    AboutAccountViewQuery,
    AboutAccountViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<AboutAccountViewQuery, AboutAccountViewQueryVariables>(
    AboutAccountViewDocument,
    options,
  )
}
export function useAboutAccountViewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    AboutAccountViewQuery,
    AboutAccountViewQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    AboutAccountViewQuery,
    AboutAccountViewQueryVariables
  >(AboutAccountViewDocument, options)
}
// @ts-ignore
export function useAboutAccountViewSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    AboutAccountViewQuery,
    AboutAccountViewQueryVariables
  >,
): Apollo.UseSuspenseQueryResult<
  AboutAccountViewQuery,
  AboutAccountViewQueryVariables
>
export function useAboutAccountViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AboutAccountViewQuery,
        AboutAccountViewQueryVariables
      >,
): Apollo.UseSuspenseQueryResult<
  AboutAccountViewQuery | undefined,
  AboutAccountViewQueryVariables
>
export function useAboutAccountViewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        AboutAccountViewQuery,
        AboutAccountViewQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions }
  return Apollo.useSuspenseQuery<
    AboutAccountViewQuery,
    AboutAccountViewQueryVariables
  >(AboutAccountViewDocument, options)
}
export type AboutAccountViewQueryHookResult = ReturnType<
  typeof useAboutAccountViewQuery
>
export type AboutAccountViewLazyQueryHookResult = ReturnType<
  typeof useAboutAccountViewLazyQuery
>
export type AboutAccountViewSuspenseQueryHookResult = ReturnType<
  typeof useAboutAccountViewSuspenseQuery
>
export type AboutAccountViewQueryResult = Apollo.QueryResult<
  AboutAccountViewQuery,
  AboutAccountViewQueryVariables
>
